import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    poSummary: {
        outline: 'none'
    },
    invalidInvoiceContainer: {
        display: 'flex',
        alignItems: 'end',
        gap: '1rem',
        width: '100%',
        fontWeight: 'normal',
        justifyContent: 'space-between',
    },
    iconWarning: {
        color: 'RED',
        height: '24px',
        width: '24px',
        verticalAlign: 'middle',
    },
});
